import type React from 'react';

import { Divider, FormField, Input, Label } from '@zillow/constellation-10';
import { Box } from '@zillow/constellation-10';

import type { Section } from '../../../../models/index';
import { HEATING_OIL } from '../../../../constants';
import HeaderToggle from '../Utilities/HeaderToggle';
import SwitchWithTitle from '../../../Widgets/SwitchWithTitle';

type Props = {
  section: Section;
  setSectionValues: (keyValuePairs: object) => void;
  children?: React.ReactNode;
  additionalFields?: object;
};

const INITIAL_STATE = {
  [HEATING_OIL.FIELD_NAME.IS_ENABLED]: true,
  [HEATING_OIL.FIELD_NAME.TENANT_PAYS_IN_ADDITION_TO_RENT]: false,
  [HEATING_OIL.FIELD_NAME.SERVICE_PROVIDER]: '',
};

export default function HeatingOil_v1({ additionalFields, children, section, setSectionValues }: Props): JSX.Element {
  const heatingOil_isEnabled = section.getFieldValue(HEATING_OIL.FIELD_NAME.IS_ENABLED);
  const heatingOil_paysInAdditionIsToggled = section.getFieldValue(
    HEATING_OIL.FIELD_NAME.TENANT_PAYS_IN_ADDITION_TO_RENT,
  );

  function toggleUtility(): void {
    setSectionValues({
      ...INITIAL_STATE,
      [HEATING_OIL.FIELD_NAME.IS_ENABLED]: !section.getFieldValue(HEATING_OIL.FIELD_NAME.IS_ENABLED),
      ...additionalFields,
    });
  }

  function togglePaysInAddition(): void {
    setSectionValues({
      ...INITIAL_STATE,
      [HEATING_OIL.FIELD_NAME.TENANT_PAYS_IN_ADDITION_TO_RENT]: !section.getFieldValue(
        HEATING_OIL.FIELD_NAME.TENANT_PAYS_IN_ADDITION_TO_RENT,
      ),
      ...additionalFields,
    });
  }

  function setServiceProvider(event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>): void {
    setSectionValues({
      [HEATING_OIL.FIELD_NAME.SERVICE_PROVIDER]: event.currentTarget.value,
    });
  }

  return (
    <>
      <HeaderToggle
        header="Heating oil"
        subheader="Applies to this property"
        switchOn={heatingOil_isEnabled}
        onSwitchToggle={toggleUtility}
      />
      {heatingOil_isEnabled && (
        <>
          <Divider css={{ marginTop: 'layout.tighter', marginBottom: 'layout.tighter' }} />
          <SwitchWithTitle
            text="Tenant pays in addition to base rent"
            onClick={togglePaysInAddition}
            toggled={heatingOil_paysInAdditionIsToggled}
          />
          {heatingOil_paysInAdditionIsToggled && (
            <>
              <FormField
                required
                css={{ marginTop: 'layout.tight' }}
                label={
                  <Label id="service-provider">
                    Your tenant will be responsible for cost and account set up and will pay directly to which service
                    provider?
                  </Label>
                }
                control={
                  <Input
                    aria-labelledby="service-provider"
                    value={section.getFieldValue(HEATING_OIL.FIELD_NAME.SERVICE_PROVIDER)}
                    onChange={setServiceProvider}
                  />
                }
              />
              {children && <Box css={{ marginTop: 'layout.tight' }}>{children}</Box>}
            </>
          )}
        </>
      )}
    </>
  );
}
